import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { Button, Dropdown, DropdownItem, DropdownToggle, DropdownMenu } from 'reactstrap';
import { ACCOUNTANT_URL, DOCS_URL, RISK_URL, USERS_URL, WORKFLOW_URL, REASEGURO_URL, ANALYST_URL, SINIESTROS_URL, ORSAN_LOGO_URL } from '../CONST';
import { signout } from '../helpers/auth';
import getUserHome from '../helpers/routeHelper';
import isUserHasProfile from '../helpers/profileValidator';
import {
  POLICY_READ,
  GENERAL_CONDITIONED_READ,
  CREDITO_NAVBAR,
} from '../helpers/profilePermission';
import NotificationBell from './shared/NotificationBell';

class BaseNavbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appsOpen: false,
      guaranteeDropdownOpen: false,
      creditDropdownOpen: false,
    };
  }

  toggleApps = () => {
    this.setState((prevState) => ({
      appsOpen: !prevState.appsOpen,
    }));
  };

  toggleGuaranteeDropdown = () => {
    this.setState((prevState) => ({
      guaranteeDropdownOpen: !prevState.guaranteeDropdownOpen,
    }));
  };

  toggleCreditDropdown = () => {
    this.setState((prevState) => ({
      creditDropdownOpen: !prevState.creditDropdownOpen,
    }));
  };

  handleSignOut = (event) => {
    event.preventDefault();
    signout();
  };

  redirectWithToken = (event) => {
    event.preventDefault();
    const { token } = this.props;

    const url = event.target.href;

    const options = {
      method: 'GET',
      headers: {
        'X-JWT-TOKEN': token,
      },
      credentials: 'include',
    };

    fetch(url, options)
      .then((response) => {
        if (response.ok) {
          window.location.href = url;
        }
      })
      .catch(() => {});
  }

  getSelectedClass = (path, exact = false) => {
    const currentPath = window.location.pathname;

    const { user } = this.props;

    // Maneja un arreglo the "paths"
    if (Array.isArray(path)) {
      if (path.some(p => exact ? currentPath === p : currentPath.startsWith(p)))
        return 'nav-selected';
    }

    if (typeof path === 'string') {
      if (exact ? currentPath === path : currentPath.startsWith(path))
        return 'nav-selected';
    }

    if (currentPath === "/" && user) {
      const { path: homePath } = getUserHome(user);

      // Maneja el "home path"
      if (Array.isArray(path) ? path.includes(homePath) : homePath === path)
        return 'nav-selected';
    }

    return '';
  };

  render() {
    const { user } = this.props;
    const { guaranteeDropdownOpen, creditDropdownOpen, appsOpen } = this.state;

    return (
      user && (
        <nav className="navbar-content">
          <div className="nav-logo-container">
            <Link to="/">
              <img src={ORSAN_LOGO_URL} className="nav-logo" alt="" />
            </Link>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr auto' }}>
            <ul className="nav-links-group">
              <Dropdown nav className="nav-link-element" isOpen={appsOpen} toggle={this.toggleApps}>
                <DropdownToggle nav caret className="navbar-header">
                  PÓLIZA
                </DropdownToggle>
                <DropdownMenu>
                  {user.apps.includes('users') && (
                    <DropdownItem>
                      <a className="nav-link navbar-header" href={USERS_URL}>
                        USUARIOS
                      </a>
                    </DropdownItem>
                  )}
                  {user.apps.includes('docs') && (
                    <DropdownItem>
                      <a className="nav-link navbar-header" href={DOCS_URL}>
                        DOCUMENTOS
                      </a>
                    </DropdownItem>
                  )}
                  {user.apps.includes('accountant') && (
                    <DropdownItem>
                      <a className="nav-link navbar-header" href={ACCOUNTANT_URL}>
                        RESERVAS
                      </a>
                    </DropdownItem>
                  )}
                  {user.apps.includes('reaseguro') && (
                    <DropdownItem>
                      <a className="nav-link navbar-header" href={REASEGURO_URL}>
                        REASEGURO
                      </a>
                    </DropdownItem>
                  )}
                  {user.apps.includes('risk') && (
                    <DropdownItem>
                      <a className="nav-link navbar-header" href={RISK_URL}>
                        RIESGO
                      </a>
                    </DropdownItem>
                  )}
                  {user.apps.includes('analista') && (
                    <DropdownItem>
                      <a className="nav-link navbar-header" href={ANALYST_URL}>
                        RIESGO DE CRÉDITO
                      </a>
                    </DropdownItem>
                  )}
                  {user.apps.includes('workflow') && (
                    <DropdownItem>
                      <a className="nav-link navbar-header" href={WORKFLOW_URL}>
                        SEGURO DE CRÉDITO
                      </a>
                    </DropdownItem>
                  )}
                  {user.is_orsan && (
                    <DropdownItem>
                      <a className="nav-link navbar-header" href={SINIESTROS_URL} onClick={this.redirectWithToken}>
                        SINIESTROS
                      </a>
                    </DropdownItem>
                  )}
                </DropdownMenu>
              </Dropdown>
              {isUserHasProfile(POLICY_READ) && (
                <Dropdown
                  nav
                  className="nav-link-element"
                  isOpen={guaranteeDropdownOpen}
                  toggle={this.toggleGuaranteeDropdown}
                >
                  <DropdownToggle nav caret className={`nav-pill ${this.getSelectedClass(['/guarantee', '/garantia'])}`}>
                    Garantía
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem>
                      <Link className={`nav-link ${this.getSelectedClass('/guarantee/policies')}`} to="/guarantee/policies">
                        Pólizas
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link className={`nav-link ${this.getSelectedClass('/garantia/proyectos')}`} to="/garantia/proyectos">
                        Venta en Verde
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link className={`nav-link ${this.getSelectedClass('/guarantee/oportunities')}`} to="/guarantee/oportunities">
                        Oportunidades
                      </Link>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              )}
              {isUserHasProfile(CREDITO_NAVBAR) && (
                <Dropdown
                  nav
                  className="nav-link-element"
                  isOpen={creditDropdownOpen}
                  toggle={this.toggleCreditDropdown}
                >
                  <DropdownToggle nav caret className={`nav-pill ${this.getSelectedClass('/credit/policies')}`}>
                    Crédito
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem>
                      <Link className={`nav-link ${this.getSelectedClass('/credit/policies')}`} to="/credit/policies">
                        Pólizas
                      </Link>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              )}
              {isUserHasProfile(GENERAL_CONDITIONED_READ) && (
                <li className="nav-link-element nav-item dropdown">
                  <Link className={`nav-link nav-pill ${this.getSelectedClass('/condicionados')}`} to="/condicionados">
                    Condicionados Generales
                  </Link>
                </li>
              )}
            </ul>
            <ul className="nav-links-group">
              <li className="nav-link-element nav-ite">
                <NotificationBell />
              </li>
              <li className="nav-link-element nav-ite dropdown">
                <p className="nav-link">{user ? user.username : ''}</p>
              </li>
              <li className="nav-link-element nav-item dropdown">
                <Button className="btn-outline-orsan-logout mr-3" onClick={this.handleSignOut}>
                  Cerrar Sesión
                  <FontAwesomeIcon icon={faSignOutAlt} size="1x" className="ml-2" />
                </Button>
              </li>
            </ul>
          </div>
        </nav>
      )
    );
  }
}

BaseNavbar.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string,
    username: PropTypes.string,
    full_name: PropTypes.string,
    has_access: PropTypes.bool,
    apps: PropTypes.arrayOf(PropTypes.string),
    organization: PropTypes.number,
    sub: PropTypes.string,
    is_orsan: PropTypes.bool,
  }).isRequired,
  token: PropTypes.string,
};

BaseNavbar.defaultProps = {
  token: undefined,
};

const mapStateToProps = (state) => ({
  user: state.login.user,
  login: state.login,
  token: state.login.id_token,
});

export default withRouter(connect(mapStateToProps)(BaseNavbar));
